var _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSiSpecial(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 26,
    fill: "url(#paint0_linear_538_1051)",
    fillOpacity: 0.12
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 26,
    stroke: "url(#paint1_linear_538_1051)",
    strokeWidth: 4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 26,
    stroke: "url(#paint2_linear_538_1051)",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2257 38.1959C23.7884 38.1959 22.5004 37.9625 21.3617 37.4959C20.223 37.0292 19.3084 36.3385 18.6177 35.4239C17.9457 34.5092 17.591 33.4079 17.5537 32.1199H22.6497C22.7244 32.8479 22.9764 33.4079 23.4057 33.7999C23.835 34.1732 24.395 34.3599 25.0857 34.3599C25.795 34.3599 26.355 34.2012 26.7657 33.8839C27.1764 33.5479 27.3817 33.0905 27.3817 32.5119C27.3817 32.0265 27.2137 31.6252 26.8777 31.3079C26.5604 30.9905 26.159 30.7292 25.6737 30.5239C25.207 30.3185 24.535 30.0852 23.6577 29.8239C22.3884 29.4319 21.3524 29.0399 20.5497 28.6479C19.747 28.2559 19.0564 27.6772 18.4777 26.9119C17.899 26.1465 17.6097 25.1479 17.6097 23.9159C17.6097 22.0865 18.2724 20.6585 19.5977 19.6319C20.923 18.5865 22.6497 18.0639 24.7777 18.0639C26.943 18.0639 28.6884 18.5865 30.0137 19.6319C31.339 20.6585 32.0484 22.0959 32.1417 23.9439H26.9617C26.9244 23.3092 26.691 22.8145 26.2617 22.4599C25.8324 22.0865 25.2817 21.8999 24.6097 21.8999C24.031 21.8999 23.5644 22.0585 23.2097 22.3759C22.855 22.6745 22.6777 23.1132 22.6777 23.6919C22.6777 24.3265 22.9764 24.8212 23.5737 25.1759C24.171 25.5305 25.1044 25.9132 26.3737 26.3239C27.643 26.7532 28.6697 27.1639 29.4537 27.5559C30.2564 27.9479 30.947 28.5172 31.5257 29.2639C32.1044 30.0105 32.3937 30.9719 32.3937 32.1479C32.3937 33.2679 32.1044 34.2852 31.5257 35.1999C30.9657 36.1145 30.1444 36.8425 29.0617 37.3839C27.979 37.9252 26.7004 38.1959 25.2257 38.1959Z",
    fill: "url(#paint3_linear_538_1051)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2257 38.1959C23.7884 38.1959 22.5004 37.9625 21.3617 37.4959C20.223 37.0292 19.3084 36.3385 18.6177 35.4239C17.9457 34.5092 17.591 33.4079 17.5537 32.1199H22.6497C22.7244 32.8479 22.9764 33.4079 23.4057 33.7999C23.835 34.1732 24.395 34.3599 25.0857 34.3599C25.795 34.3599 26.355 34.2012 26.7657 33.8839C27.1764 33.5479 27.3817 33.0905 27.3817 32.5119C27.3817 32.0265 27.2137 31.6252 26.8777 31.3079C26.5604 30.9905 26.159 30.7292 25.6737 30.5239C25.207 30.3185 24.535 30.0852 23.6577 29.8239C22.3884 29.4319 21.3524 29.0399 20.5497 28.6479C19.747 28.2559 19.0564 27.6772 18.4777 26.9119C17.899 26.1465 17.6097 25.1479 17.6097 23.9159C17.6097 22.0865 18.2724 20.6585 19.5977 19.6319C20.923 18.5865 22.6497 18.0639 24.7777 18.0639C26.943 18.0639 28.6884 18.5865 30.0137 19.6319C31.339 20.6585 32.0484 22.0959 32.1417 23.9439H26.9617C26.9244 23.3092 26.691 22.8145 26.2617 22.4599C25.8324 22.0865 25.2817 21.8999 24.6097 21.8999C24.031 21.8999 23.5644 22.0585 23.2097 22.3759C22.855 22.6745 22.6777 23.1132 22.6777 23.6919C22.6777 24.3265 22.9764 24.8212 23.5737 25.1759C24.171 25.5305 25.1044 25.9132 26.3737 26.3239C27.643 26.7532 28.6697 27.1639 29.4537 27.5559C30.2564 27.9479 30.947 28.5172 31.5257 29.2639C32.1044 30.0105 32.3937 30.9719 32.3937 32.1479C32.3937 33.2679 32.1044 34.2852 31.5257 35.1999C30.9657 36.1145 30.1444 36.8425 29.0617 37.3839C27.979 37.9252 26.7004 38.1959 25.2257 38.1959Z",
    fill: "url(#paint4_linear_538_1051)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8883 18.3439V37.9999H33.1003V18.3439H37.8883ZM38.7563 14.3959L32.0083 17.2239V13.9199L38.7563 10.6719V14.3959Z",
    fill: "url(#paint5_linear_538_1051)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8883 18.3439V37.9999H33.1003V18.3439H37.8883ZM38.7563 14.3959L32.0083 17.2239V13.9199L38.7563 10.6719V14.3959Z",
    fill: "url(#paint6_linear_538_1051)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_538_1051",
    x1: 0,
    y1: 0,
    x2: 28,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BDD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DFFCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_538_1051",
    x1: 0,
    y1: 0,
    x2: 28,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BDD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DFFCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_538_1051",
    x1: 28,
    y1: 1.24726e-8,
    x2: 28,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFFA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF8A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_538_1051",
    x1: 16,
    y1: 7,
    x2: 42.0177,
    y2: 36.7345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BDD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DFFCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_538_1051",
    x1: 28,
    y1: 7,
    x2: 28,
    y2: 49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFFA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF8A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_538_1051",
    x1: 16,
    y1: 7,
    x2: 42.0177,
    y2: 36.7345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BDD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DFFCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_538_1051",
    x1: 28,
    y1: 7,
    x2: 28,
    y2: 49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFFA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF8A00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiSpecial);
export default __webpack_public_path__ + "static/media/si-special.f8f81ebb19c6b338fd19cf00bc14588f.svg";
export { ForwardRef as ReactComponent };